

































































































































import TariffCreateDialog from '@/components/Services/Remittances/Tariff/TariffCreateDialog.vue'
import ActionButton from '@/components/ActionButton.vue'
import Table from '@/components/Table.vue'
import { getTariffs, activeTariff } from '@/api/Remittances/remittances.api'
import { Tariff } from '@/utils/interfaces/remittance.interface'
import { VueTable, TableHeader, Params } from '@/utils/interfaces'
import DetailsDialog from '@/components/Services/Remittances/Tariff/DetailsDialog.vue'
import TariffFilter from '@/components/Services/Remittances/Tariff/TariffFilter.vue'
import { tableHandler } from '@/utils/mixins/tableHandler'
import UpdateMultipleTariffButton from '@/components/UpdateMultipleTariffButton.vue'
import FlatCard from '~/components/FlatCard.vue'
import TextButton from '~/components/TextButton.vue'
import DeleteTariffButton from './DeleteTariffButton.vue'
import DeleteMultipleTariffs from '~/components/Services/Remittances/Tariff/DeleteMultipleTariffs.vue'

export default tableHandler<Tariff>().extend({
  components: {
    appTariffCreateDialog: TariffCreateDialog,
    appActionButton: ActionButton,
    appTariffFilter: TariffFilter,
    appTable: Table,
    appDetailsDialog: DetailsDialog,
    UpdateMultipleTariffButton,
    FlatCard,
    TextButton,
    DeleteTariffButton,
    DeleteMultipleTariffs,
  },
  data() {
    return {
      tabs: 0,
      infoDialog: false,
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('interval') + ' ($)',
          value: 'interval',
        },
        {
          text: this.$t('minimum-commission') + ' ($)',
          value: 'min_commission',
        },
        {
          text: this.$t('percent-commission') + ' (%)',
          value: 'percent_commission',
        },
        {
          text: this.$t('delivery_currency'),
          value: 'delivery_currency',
        },
        {
          text: this.$t('exchange_rate'),
          value: 'exchange_rate',
        },
        {
          text: this.$t('active'),
          value: 'is_active',
        },
        {
          text: this.$t('province'),
          value: 'region_name',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
      multiple: true,
      activeItem: null as null | Tariff,
      selectedTariffs: [] as string[],
    }
  },
  methods: {
    getterClients: (params?: Params) =>
      getTariffs({ ...params, type: 'CLIENT' }),
    getterAgencies: (params?: Params) =>
      getTariffs({ ...params, type: 'AGENCY' }),
    onCreateTariff() {
      this.multiple = true
      this.onCreate()
    },
    onCreateCopy(item: Tariff) {
      this.multiple = true
      this.onCopy(item)
    },
    newFilter(payload: Params) {
      const tables = this.$refs.table as VueTable[]
      tables[this.tabs].newFilter(payload)
    },
    onDetails(item: Tariff): void {
      this.$store.commit('remittance/data', item)
      this.infoDialog = true
    },
    async onChange(item: Tariff) {
      try {
        this.activeItem = item
        await activeTariff({
          is_active: item.is_active,
          uuid: item.uuid,
        })
      } catch {
        item.is_active = !item.is_active
      } finally {
        this.activeItem = null
      }
    },
    refresh() {
      this.table.refresh()
    },
    refreshMultiple() {
      this.selectedTariffs = []
      this.refresh()
    },
  },
  computed: {
    customHeaders(): TableHeader[] {
      const headers = [...this.headers]
      if (this.tabs === 1) {
        headers.splice(1, 1, {
          text: this.$t('agency.to_agency'),
          value: 'to_agency_name',
        })
      }
      return headers
    },
    table(): VueTable {
      const tables = this.$refs.table as VueTable[]
      return tables[this.tabs]
    },
    tariffType(): 'CLIENT' | 'AGENCY' {
      return !this.tabs ? 'CLIENT' : 'AGENCY'
    },
  },
  watch: {
    tabs(value: number) {
      if (!value) {
        this.multiple = false
      }
    },
  },
})
